import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import InfoCard from '../InfoCard';
import { CopyIcon } from '../Icon';
import styles from './CoordsInfoPanel.module.css';

const CoordsInfoPanel = ({ info, onClose, onFeatureClick }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(!!info);
    }, [info]);

    if (!info) {
        return null;
    }

    const { coordinates, features } = info;

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => toast.success('Координаты скопированы!'))
            .catch(() => toast.error('Не удалось скопировать'));
    };

    const getFeatureName = (feature) => {
        return feature.properties.name || feature.properties.cadastral_number || `Объект (ID: ${feature.id.slice(0, 8)}...)`;
    };

    const getFeatureTypeLabel = (type) => {
        const labels = {
            plot: 'Участок',
            building: 'Здание',
            road: 'Дорога',
            line: 'Линия',
            marker: 'Метка',
        };
        return labels[type] || type;
    };

    return (
        <div className={`${styles.coordsPanel} ${isVisible ? styles.visible : ''}`}>
            <InfoCard
                title="Информация по точке"
                variant="outlined"
                className={styles.mainInfoCard}
                actions={[{ label: 'Закрыть', onClick: onClose, variant: 'default' }]}
            >
                <div className={styles.content}>
                    <div className={styles.section}>
                        <h4 className={styles.sectionTitle}>Координаты</h4>
                        <div className={styles.coordsItem} onClick={() => handleCopy(`${coordinates.lat.toFixed(6)}, ${coordinates.lng.toFixed(6)}`)}>
                            <span>Lat: {coordinates.lat.toFixed(6)}</span>
                            <span>Lng: {coordinates.lng.toFixed(6)}</span>
                            <CopyIcon className={styles.copyIcon} size={16} />
                        </div>
                    </div>

                    <div className={styles.section}>
                        <h4 className={styles.sectionTitle}>Объекты в этой точке ({features.length})</h4>
                        {features.length > 0 ? (
                            <ul className={styles.featureList}>
                                {features.map((feature, index) => (
                                    <li
                                        key={feature.id || index}
                                        className={`${styles.featureListItem} ${onFeatureClick ? styles.clickable : ''}`}
                                        onClick={() => onFeatureClick?.(feature)}
                                    >
                                        <span className={styles.featureType}>{getFeatureTypeLabel(feature.properties.type)}</span>
                                        <span className={styles.featureName}>{getFeatureName(feature)}</span>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className={styles.noFeatures}>Объекты не найдены.</p>
                        )}
                    </div>
                </div>
            </InfoCard>
        </div>
    );
};

export default CoordsInfoPanel;